import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { ModuleManagerExportFormat } from 'src/shared/models/module-manager/module-manager-options.model';
import { CxoneDispositionsData } from './cxone-dispositions.model';

@Injectable({
	providedIn: 'root'
})
export class CxoneDispositionsService {
	constructor(
		private cvApiService: CVApiService
	) { }

	async loadData(moduleKey: string, isAutoRefresh = false, isFirstLoad = false, isCXOne = false): Promise<CxoneDispositionsData> {
		try {
			const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
			const query = `/api/v3/dashboards/modules/cxoneDispositions/`;
			const queryAll = query + `${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
			const response = await this.cvApiService.get<CxoneDispositionsData>(queryAll, renderEndpoint);
			if (response.status_code >= 200 && response.status_code < 300)
				return response.data;
			else throw response;
		}
		catch (err) {
			console.error('Failed to load dispositions data');
			throw err;
		}
	}

	async LoadDataForExport(moduleKey: string, format: ModuleManagerExportFormat): Promise<any> {
        try {
            const moduleRenderURL = await this.cvApiService.getModuleRenderEndPoint(moduleKey);

            const queryString = `/export?format=${format}`;
            const url = `/api/v3/dashboards/modules/cxoneDispositions/${moduleKey}${queryString}`;

            const response = await this.cvApiService.get<string>(url, moduleRenderURL);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        }
        catch (err) {
            console.error("Failed to get dispositions export data");
            throw err;
        }
    }
}
